import React from 'react';
import Content, { options } from '@components/Content';
import { FaqProps } from 'ech-components/src/components/Faq';
import { IntlShape } from 'react-intl';
import { ContentReference } from '~/components/Content/helpers';

const faqService = (
  data: {
    faqs: [];
    title?: string;
    leadText?: { leadText?: string };
  },
  intl: IntlShape,
) => {
  const contactBox = {
    link: '',
    button1: intl.formatMessage({
      id: `teaser.faq.contact.ladestationinfrastruktur.mailLink`,
    }),
    button2: intl.formatMessage({
      id: `teaser.faq.contact.ladestationinfrastruktur.phoneLink`,
    }),
    labels: {
      more: '',
      title: intl.formatMessage({
        id: `teaser.faq.contact.ladestationinfrastruktur.title`,
      }),
      text: intl.formatMessage(
        {
          id: `teaser.faq.contact.ladestationinfrastruktur.text`,
        },
        {
          br: <br />,
        },
      ),
      mail: intl.formatMessage({
        id: `teaser.faq.contact.ladestationinfrastruktur.mailText`,
      }),
      phone: intl.formatMessage({
        id: `teaser.faq.contact.ladestationinfrastruktur.phone`,
      }),
    },
  };

  const faqProps: FaqProps = data?.faqs
    ? {
        items: data.faqs.map(
          ({
            question,
            answer,
          }: {
            question: string;
            answer: {
              raw: string;
              references: ContentReference[];
            };
          }) => {
            return {
              question,
              richtext: <Content content={answer} options={options} nested />,
            };
          },
        ),
        title: data.title,
        lead: data?.leadText?.leadText,
        contactBox,
        gridItemSize: { zero: 12, medium: 10, large: 8 },
        gridItemPush: { zero: 0, medium: 1, large: 2 },
      }
    : null;

  return faqProps;
};

export default faqService;
